import React from 'react';
import {formatDateTime} from '../../utils/helpers';

const DayHeader = ({days}) => {
    return (
        <thead className="bg-custom-charcoal/60">
            <tr>
                <th className="pl-2 py-1 text-xs text-custom-light-grey font-bold">
                    <div className="flex items-center gap-2">
                        <span>Metric</span>
                    </div>
                </th>
                {days.map((day, index) => {
                    const formattedDate = formatDateTime(day);
                    return (
                        <th key={day} className="py-1 text-xs text-center">
                            <span>{formattedDate.shortDayName}</span><br />
                            <span className='text-base'>{formattedDate.dayOfMonth}</span>
                        </th>
                    )
                })}
            </tr>
        </thead>
    )
}

export default DayHeader;